<template>
  <div class="block-undertittel">
    <component
      v-if="this.$i18n.locale == 'no'"
      :is="'h' + level"
      v-html="content"
    ></component>
    <div v-else>
      <component
        v-if="content_eng"
        :is="'h' + level"
        v-html="content_eng"
      ></component>
    </div>
    <div class="scroll-anchor" :id="slug"></div>
  </div>
</template>

<script>
import Renderer from "./mixin";
import { Slugify } from "@/utils";

export default {
  props: {
    chapter: String,
    level: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    slug() {
      return [Slugify(this.chapter), Slugify(this.content)]
        .filter(Boolean)
        .join("-");
    },
    content() {
      return this.Undertittel || this.Tittel;
    },
    content_eng() {
      return this.Undertittel_eng || this.Tittel_eng;
    },
  },

  mixins: [
    Renderer(["Undertittel", "Tittel", "Undertittel_eng", "Tittel_eng"]),
  ],
};
</script>

<style lang="scss">
.block-undertittel {
  position: relative;
  .scroll-anchor {
    top: -5rem;
    position: absolute;
  }
}
</style>
